import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VetUserModel } from '../models/vet-users/vet-user.model';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { VetMemberAccountModel } from '../models/vet-users/vet-member-account.model';
import { SpinnerService } from '../shared-new/services/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class VetUsersService {
  public baseUrl = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');
  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: '',
  };

  public constructor(private readonly http: HttpClient, private spinnerService: SpinnerService) { }

  public getVetMemberAccounts(saleId: number): Observable<VetMemberAccountModel[]> {
    this.spinnerService.addRequest('getVetMemberAccounts');
    return this.http.get<VetMemberAccountModel[]>(
      `${this.baseUrl}/api/member/${saleId}/VetMemberAccounts`,
      {
        withCredentials: false,
        observe: 'response'
      }
    ).pipe(map((res) => {
        this.spinnerService.popRequest('getVetMemberAccounts');
        return res.body;
      }),
      catchError((error: Error) => {
        this.spinnerService.popRequest('getVetMemberAccounts');
        this.onError.next(error.message);
        return throwError(error);
      })
    );
  }
}
